// extracted by mini-css-extract-plugin
module.exports = {"withdrawal-survey-page":"withdrawal-survey-page__2wY0a"};